import { useEffect } from 'react';
import { useAppStore } from '../store/appStore';
import { syncApiServiceWithStore } from '../services/api';

/**
 * Hook to automatically sync the API service with the current authentication tokens
 * Use this in any component that needs to make authenticated API calls
 */
export const useApiSync = () => {
  const { tokens } = useAppStore();

  useEffect(() => {
    syncApiServiceWithStore(tokens);
  }, [tokens]);

  return { tokens };
};
